// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.notifications/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.notifications/route.tsx");
  import.meta.hot.lastModified = "1693367923221.387";
}
// REMIX HMR END

import invariant from 'tiny-invariant';
import { getCapitalized } from '~/utils.server';
const TITLE = 'notifications';
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  return {
    title
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE,
  leaf: true
};
export default function Index() {
  return <div>
      <h1>notifications</h1>
    </div>;
}
_c = Index;
var _c;
$RefreshReg$(_c, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;